var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"auth-bg"},[_c('div',{staticClass:"authentication-box"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('Authorization')],1)])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }